import React from "react";
import Testimonials from "../../components/shared/testimonials";

import TestiLightDesktopBg from "../../images/online/testimonial-bg-desktop-light.png";
import TestiDarkDesktopBg from "../../images/online/testimonial-bg-desktop-dark.png";
import DarkIllustration from "../../images/illustrations/program-tabs-ill-dark.inline.svg";
import LightIllustration from "../../images/illustrations/Anemone-Illustration-light.inline.svg";

const CourseContact = () => {
  return (
    <section key={"find-out-more"} id={"find-out-more"}>
      <Testimonials
        type="online_enquiry"
        form_type="gvionline_enquiry_form"
        bgType="unity"
        heading="Want to find out more about this course?"
        bgSrc={{
          light: { desktop: TestiLightDesktopBg },
          planet: { desktop: TestiDarkDesktopBg }
        }}
        illustrationSrc={{
          planet: (
            <DarkIllustration className="!absolute hidden planet:md:block -left-[3vw] -top-[7vw] w-[25vw] opacity-10 stroke-gray-generic -scale-x-100" />
          ),
          light: (
            <LightIllustration className="!absolute opacity-15 top-[8%] -left-[22%] !hidden sm:!block sm:planet:!hidden" />
          )
        }}
        testimonialContainerBg={
          "bg-white/10 gvi-blur-bg md:blur-none planet:gvi-blur-newsletter-bg planet:gvi-blur-bg rounded-xxs flex-wrap border-0.5 border-gray-testimonial/30"
        }
        formTooltipIconStyles={"fill-white planet:fill-white"}
        calendlyLayout={"popup"}
        calendlyDesc={"Alternatively, schedule a call time above via Calendly."}
        formStatusExtraContainerClass={""}
        formStatusIconColorClass={"text-white fill-white"}
        formStatusHeadingTextProcessing={"Just a moment..."}
        formStatusBriefTextProcessing={
          "We're making sure we have everything we need before connecting you with one of our team members."
        }
        formStatusHeadingTextSuccess={"Thank you!"}
        formStatusBriefTextSuccess={
          "One of our expert consultants will be in touch within 12 hours. If you can't wait to speak to us, you can call us on INTL_NUMBER"
        }
      />
    </section>
  );
};

export default CourseContact;
